import type { Program } from '@efdigital/ll-addon-data';
import { DataTypeXceed } from '@efdigital/ll-addon-data/data-types/xceed';
import { debounce } from '@efdigital/ll-addon-ui';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { ReactiveDataDocument } from '@warp-drive/core/reactive';
import { withReactiveResponse } from '@warp-drive/core/request';
import type { RequestInfo } from '@warp-drive/core/types/request';
import { query } from '@warp-drive/utilities/json-api';

import { filterRegex, include, page, sort } from '../../data/json-api.ts';
import { jsonApiOptions } from '../../lib/json-api.ts';

export class SearchProgramsState {
  @tracked text = '';
  @tracked offset = 0;
  @tracked limit = 20;
}

interface SearchPagerSignature {
  Args: {
    legend: string;
    state: Readonly<SearchProgramsState>;
    setState: (state: Partial<SearchProgramsState>) => void;
  };
  Blocks: {
    query: [RequestInfo<ReactiveDataDocument<Program[]>>];
  };
}

export class SearchPrograms extends Component<SearchPagerSignature> {
  get query() {
    return withReactiveResponse<Program[]>(
      query(
        DataTypeXceed.Program,
        {
          ...filterRegex('filter[title]', this.args.state.text),
          ...page(this.args.state),
          ...include(['client']),
          ...sort('title'),
        },
        jsonApiOptions
      )
    );
  }

  updateText = (event: Event) => {
    this.args.setState({
      text: (event.target as HTMLInputElement).value,
      offset: 0,
    });
  };

  <template>
    <fieldset>
      <legend class="gud-eyebrow">{{@legend}}</legend>
      <div class="form-group">
        <label for="search" class="form-label">Title</label>
        <input
          type="text"
          id="search"
          class="form-control"
          placeholder="Search..."
          value={{@state.text}}
          {{debounce this.updateText}}
        />
      </div>
    </fieldset>
    {{yield this.query to="query"}}
  </template>
}
